import { render, staticRenderFns } from "./FisaDepozit.vue?vue&type=template&id=173ca468&scoped=true"
import script from "./FisaDepozit.vue?vue&type=script&lang=js"
export * from "./FisaDepozit.vue?vue&type=script&lang=js"
import style0 from "./FisaDepozit.vue?vue&type=style&index=0&id=173ca468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ca468",
  null
  
)

export default component.exports